// Analytics tracking utility - Integrated with Google Analytics 4
// Measurement ID: G-2QC7KXKR8Y

class Analytics {
  // Track custom events
  static trackEvent(eventName, eventData = {}) {
    const timestamp = new Date().toISOString();
    const event = {
      event: eventName,
      timestamp,
      ...eventData
    };

    // Log to console
    console.log('[Analytics]', event);

    // Store in localStorage for debugging
    try {
      const events = JSON.parse(localStorage.getItem('mg_ai_analytics') || '[]');
      events.push(event);
      // Keep only last 100 events
      if (events.length > 100) events.shift();
      localStorage.setItem('mg_ai_analytics', JSON.stringify(events));
    } catch (error) {
      console.error('Failed to store analytics event:', error);
    }

    // Send to Google Analytics 4
    if (window.gtag) {
      window.gtag('event', eventName, {
        ...eventData,
        event_category: eventData.category || 'engagement',
        event_label: eventData.label || eventName
      });
    }
  }

  // Track page views
  static trackPageView(pageName) {
    this.trackEvent('page_view', { 
      page: pageName,
      category: 'navigation'
    });
    
    // Explicit page_view for GA4
    if (window.gtag) {
      window.gtag('event', 'page_view', {
        page_title: pageName,
        page_location: window.location.href,
        page_path: window.location.pathname
      });
    }
  }

  // Track contact button clicks
  static trackContactClick(contactMethod, contactValue) {
    this.trackEvent('contact_click', {
      method: contactMethod,
      value: contactValue,
      category: 'contact',
      label: contactMethod
    });
    
    // Track as conversion event
    if (window.gtag) {
      window.gtag('event', 'contact_initiated', {
        contact_method: contactMethod,
        event_category: 'conversion'
      });
    }
  }

  // Track form submissions
  static trackFormSubmission(formName, formData = {}) {
    const success = formData.success !== false;
    
    this.trackEvent('form_submission', {
      form: formName,
      ...formData,
      category: 'conversion',
      label: success ? 'success' : 'error'
    });
    
    // Track as lead generation if successful
    if (success && window.gtag) {
      window.gtag('event', 'generate_lead', {
        form_name: formName,
        currency: 'INR',
        value: 1.0
      });
    }
  }

  // Track button clicks
  static trackButtonClick(buttonName, buttonLocation) {
    this.trackEvent('button_click', {
      button: buttonName,
      location: buttonLocation,
      category: 'engagement',
      label: `${buttonName} - ${buttonLocation}`
    });
  }

  // Track section views (scroll tracking)
  static trackSectionView(sectionName) {
    this.trackEvent('section_view', {
      section: sectionName,
      category: 'engagement',
      label: sectionName
    });
  }

  // Track scroll depth
  static trackScrollDepth(depth) {
    if (window.gtag) {
      window.gtag('event', 'scroll', {
        scroll_depth: depth,
        event_category: 'engagement',
        event_label: `${depth}% scrolled`
      });
    }
  }

  // Get all tracked events (for debugging)
  static getEvents() {
    try {
      return JSON.parse(localStorage.getItem('mg_ai_analytics') || '[]');
    } catch (error) {
      return [];
    }
  }

  // Clear all events
  static clearEvents() {
    localStorage.removeItem('mg_ai_analytics');
  }
}

export default Analytics;
